export default (function (_ref) {
  var request = _ref.request;
  return {
    smartControlItemAdd: function smartControlItemAdd(data) {
      return request({
        url: '/iot/smartControlItem/add',
        method: 'post',
        data: data
      });
    },
    smartControlItemModify: function smartControlItemModify(data) {
      return request({
        url: "/iot/smartControlItem/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    smartControlItemDel: function smartControlItemDel(id) {
      return request({
        url: "/iot/smartControlItem/".concat(id, "/del"),
        method: 'delete'
      });
    },
    smartControlItemQuery: function smartControlItemQuery(data) {
      return request({
        url: '/iot/smartControlItem/query',
        method: 'get',
        params: data
      });
    },
    smartControlItemDetail: function smartControlItemDetail(id) {
      return request({
        url: "/iot/smartControlItem/".concat(id, "/detail"),
        method: 'get'
      });
    },
    smartControlItemCache: function smartControlItemCache(controlId) {
      return request({
        url: "/iot/smartControlItem/cache/".concat(controlId),
        method: 'get'
      });
    },
    smartControlItemCacheClear: function smartControlItemCacheClear(params) {
      return request({
        url: "/iot/smartControlItem/cache/clear",
        method: 'DELETE',
        params: params
      });
    }
  };
});